export const ADD_TO_CART = 'ADD_TO_CART'
export const DELETE_FROM_CART = 'REMOVE_FROM_CART'
export const UPDATE_PRODUCT_QUANTITY_IN_CART = 'UPDATE_PRODUCT_QUANTITY_IN_CART'
